export enum TipoExceptionEnum {

  Exception = 500,
  RuntimeException = 500,
  SonnerException = 400,
  ServerError = 500,
  AuthorizationError = 403
}
